export default __webpack_public_path__ + "static/media/why-cova-image.bc2b576f.png";